<template>
    <section class="mobile-my-answers-page">
        <van-nav-bar title="我的问答" left-arrow fixed placeholder z-index="100" safe-area-inset-top @click-left="goBack" />

        <main class="mobile-my-answers-main">
            <section class="mobile-my-answers-hero">
                <div><span>MY QUESTIONS</span><h1>我的问答</h1><p>查看我发布的产品问题及当前处理进度。</p></div>
                <div class="mobile-my-answers-hero__total"><strong>{{ total }}</strong><span>条问答</span></div>
            </section>

            <div class="mobile-my-answers-filters">
                <button v-for="item in filters" :key="item.value" :class="{active: reviewStatus === item.value}" type="button" @click="changeFilter(item.value)">{{ item.label }}</button>
            </div>

            <div class="mobile-my-answers-heading">
                <div><h2>问答列表</h2><p>当前仅提供查看功能</p></div>
                <button type="button" @click="refresh"><van-icon name="replay" /> 刷新</button>
            </div>

            <van-list v-model="loading" :finished="finished" finished-text="没有更多问答了" @load="loadAnswers">
                <div v-if="answers.length" class="mobile-my-answer-list">
                    <article v-for="answer in answers" :key="answer.answer_id" class="mobile-my-answer-card">
                        <header>
                            <span>{{ typeTitle(answer.type_id) }}</span>
                            <div>
                                <van-tag round :type="reviewInfo(answer.review_status).type">{{ reviewInfo(answer.review_status).text }}</van-tag>
                                <van-tag round :type="Number(answer.status) === 100 ? 'success' : 'warning'">{{ Number(answer.status) === 100 ? '已解决' : '待解答' }}</van-tag>
                            </div>
                        </header>

                        <h2>{{ answer.title || '未命名问题' }}</h2>

                        <div class="mobile-my-answer-card__meta">
                            <span><van-icon name="clock-o" /> {{ formatTime(answer.create_time) }}</span>
                            <span v-if="answer.sum"><van-icon name="chat-o" /> {{ answer.sum.reply || 0 }} 个回答</span>
                        </div>

                        <van-button block round plain type="info" icon="eye-o" @click="viewAnswer(answer)">查看问题</van-button>
                    </article>
                </div>
                <van-empty v-else-if="!loading" image="search" description="暂无符合条件的问答" />
            </van-list>
        </main>
    </section>
</template>

<script>
export default {
    name: 'MobileMyAnswers',
    data() {
        return {
            answers: [],
            total: 0,
            pageNumber: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            reviewStatus: '',
            filters: [
                {label: '全部', value: ''},
                {label: '审核通过', value: 200},
                {label: '审核中', value: 1},
                {label: '未通过', value: 0},
            ],
        };
    },
    methods: {
        goBack() { this.$router.push({path: '/user/profile/setting'}); },
        changeFilter(value) {
            if (this.reviewStatus === value) return;
            this.reviewStatus = value;
            this.refresh();
        },
        refresh() {
            this.answers = [];
            this.total = 0;
            this.pageNumber = 0;
            this.finished = false;
            this.loading = true;
            this.loadAnswers();
        },
        loadAnswers() {
            const nextPage = this.pageNumber + 1;
            const search = {};
            if (this.reviewStatus !== '') search.review_status = this.reviewStatus;
            this.$bbs.get('/bbs/answer/my', {
                params: {search, sort: {}, total: this.total || 1, pageSize: this.pageSize, pageNumber: nextPage},
                need: {error: true},
            }).then(response => {
                const data = response.data || {};
                const list = Array.isArray(data.data) ? data.data : [];
                this.answers = nextPage === 1 ? list : this.answers.concat(list);
                this.total = Number(data.total) || this.answers.length;
                this.pageNumber = Number(data.pageNumber) || nextPage;
                this.finished = !list.length || this.answers.length >= this.total;
            }).catch(() => { this.finished = true; }).finally(() => { this.loading = false; });
        },
        viewAnswer(answer) { this.$router.push({path: `/wenda/detail/${answer.answer_id}.html`}); },
        typeTitle(typeId) { return ({100: 'BIGEMAP PRO', 200: 'BIGEMAP SERVER', 300: 'BIGEMAP APP'})[Number(typeId)] || '产品问答'; },
        reviewInfo(status) {
            return ({200: {text: '审核通过', type: 'success'}, 1: {text: '审核中', type: 'primary'}, 0: {text: '未通过', type: 'danger'}})[Number(status)] || {text: '审核中', type: 'primary'};
        },
        formatTime(value) {
            if (!value) return '—';
            if (typeof value === 'string' && !/^\d{10,13}$/.test(value)) return value;
            const number = Number(value); const date = new Date(number < 1000000000000 ? number * 1000 : number); const pad = item => String(item).padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
        },
    },
};
</script>

<style scoped lang="less">
.mobile-my-answers-page { min-height: 100vh; color: #1e2939; background: #f4f6f9; }
.mobile-my-answers-page /deep/ .van-nav-bar--fixed { z-index: 100 !important; background: #fff; box-shadow: 0 1px 8px rgba(24,34,53,.06); }
.mobile-my-answers-page /deep/ .van-nav-bar__title { font-size: 17px; font-weight: 650; }
.mobile-my-answers-main { padding: 12px 12px 32px; }
.mobile-my-answers-hero { display: flex; min-height: 132px; padding: 22px 19px; box-sizing: border-box; align-items: center; justify-content: space-between; color: #fff; background: radial-gradient(circle at 91% 8%,rgba(98,190,255,.35),transparent 32%),linear-gradient(140deg,#102d52,#2476c6); border-radius: 18px; box-shadow: 0 10px 28px rgba(31,96,170,.18); }
.mobile-my-answers-hero > div:first-child > span { color: #91ceff; font-size: 9px; font-weight: 800; letter-spacing: 1.2px; }
.mobile-my-answers-hero h1 { margin: 6px 0 7px; font-size: 23px; }
.mobile-my-answers-hero p { margin: 0; color: rgba(255,255,255,.7); font-size: 12px; }
.mobile-my-answers-hero__total { display: flex; width: 66px; height: 66px; flex: 0 0 66px; align-items: center; justify-content: center; flex-direction: column; background: rgba(255,255,255,.11); border: 1px solid rgba(255,255,255,.17); border-radius: 20px; }
.mobile-my-answers-hero__total strong { font-size: 23px; }
.mobile-my-answers-hero__total span { margin-top: 2px; color: rgba(255,255,255,.68); font-size: 10px; }
.mobile-my-answers-filters { display: grid; margin-top: 13px; padding: 5px; grid-template-columns: repeat(4,minmax(0,1fr)); background: #e8edf3; border-radius: 12px; gap: 4px; }
.mobile-my-answers-filters button { min-width: 0; height: 35px; padding: 0 3px; color: #788496; font-size: 12px; white-space: nowrap; background: transparent; border: 0; border-radius: 9px; }
.mobile-my-answers-filters button.active { color: #2467b6; font-weight: 650; background: #fff; box-shadow: 0 3px 9px rgba(31,52,80,.08); }
.mobile-my-answers-heading { display: flex; padding: 18px 4px 10px; align-items: flex-end; justify-content: space-between; }
.mobile-my-answers-heading h2 { margin: 0 0 4px; font-size: 18px; }
.mobile-my-answers-heading p { margin: 0; color: #929baa; font-size: 11px; }
.mobile-my-answers-heading button { padding: 5px 8px; color: #3977c6; font-size: 11px; background: #e9f2ff; border: 0; border-radius: 999px; }
.mobile-my-answer-list { display: grid; gap: 11px; }
.mobile-my-answer-card { padding: 16px 15px 14px; background: #fff; border: 1px solid #e3e8ef; border-top: 3px solid #3888e7; border-radius: 15px; box-shadow: 0 6px 20px rgba(31,49,75,.05); }
.mobile-my-answer-card header { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.mobile-my-answer-card header > span { color: #397ac6; font-size: 10px; font-weight: 750; letter-spacing: .5px; }
.mobile-my-answer-card header > div { display: flex; gap: 5px; }
.mobile-my-answer-card h2 { display: -webkit-box; margin: 14px 0 13px; overflow: hidden; color: #273246; font-size: 17px; line-height: 1.5; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
.mobile-my-answer-card__meta { display: flex; margin-bottom: 14px; align-items: center; color: #96a0ae; font-size: 11px; gap: 14px; }
.mobile-my-answer-card__meta span { display: flex; align-items: center; gap: 4px; }
.mobile-my-answer-card /deep/ .van-button--info { height: 39px; color: #2974cd; border-color: #8ab8ed; }
</style>
